import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
const Home = () => import(/* webpackChunkName: "home" */ './views/Home.vue');
const Chat = () => import(/* webpackChunkName: "chat" */ './views/Chat.vue');
const ChatToolbar = () => import(/* webpackChunkName: "chat" */ './views/ChatToolbar.vue');
const LogIn = () => import(/* webpackChunkName: "home" */ './views/LogIn.vue');
const About = () => import(/* webpackChunkName: "home" */ './views/About.vue');
const routerOptions = [
    { path: '/', name: 'home', component: Home },
    { path: '/chat', name: 'chat',
        components: { default: Chat, toolbar: ChatToolbar },
        children: [{
                path: ':botId/:conversationId'
                // Components: {
                //    default: () => import(/* webpackChunkName: "view-Chat" */ `@/views/Chat.vue`),
                //    toolbar: () => import(/* webpackChunkName: "view-Chat" */ `@/views/ChatToolbar.vue`),
                // }
            }]
    },
    { path: '/login', name: 'login', component: LogIn },
    { path: '/about', name: 'about', component: About }
];
export default new Router({
    mode: 'history',
    // routes: routerOptions
    routes: routerOptions.map((route) => {
        if (route.component) {
            return {
                ...route,
                component: route.component
            };
        }
        else {
            // const components = ;
            return {
                ...route,
                components: route.components
            };
        }
    })
});
//# sourceMappingURL=router.js.map